module.exports = __webpack_public_path__ + "img/block_bg01.2af2406e.webp";